import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function DemoEntry() {
  const { demoLogin } = useAuth();
  const nav = useNavigate();
  const [err, setErr] = useState(false);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try { await demoLogin(); nav("/"); }
      catch { setErr(true); }
    })();
  }, [demoLogin, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="demo-entry">
      {err ? (
        <div className="text-center">
          <p className="text-rose-500 font-semibold">Demo is temporarily unavailable.</p>
          <a href="/login" className="text-blue-600 text-sm underline">Go to login</a>
        </div>
      ) : (
        <p className="text-muted-foreground animate-pulse">Loading NEEC POS demo…</p>
      )}
    </div>
  );
}
